module.exports = __webpack_public_path__ + "static/media/pic8.128c79fa.jpg";